// Core
import React, { useState } from 'react';
import { Box, Button, Flex, Text, Grid, Divider, Image } from '@chakra-ui/react';

// Components
import Memberships from 'components/Membership/Membership';
import Entries from 'components/Membership/Entries';
import { StarsIcon } from '../../components/Icons/Icons';

const Membership = () => {
  const [membershipData, setMembershipData] = useState([]);
  const [paymentType, setPaymentType] = useState('yearly');

  return (
    <Box my={{base: '70px', md: '100px'}}>
      <Memberships variant="benefits" setMembershipData={setMembershipData} paymentType={paymentType} setPaymentType={setPaymentType} />
      { membershipData?.length > 0 &&
        <Entries membershipData={membershipData} membershipPaymentType={paymentType} />
      }
    </Box>
  );
};

export default Membership;